import Interaction from "../../models/interactions/Interaction";
import { getInteractionFromFactory } from "../interaction_factory/InteractionFactory";
import { useTrainingLocalization } from "../trainingLocalization/TrainingLocalizationHooks";
import { useSelector } from "react-redux";
import {
  selectActors,
  selectAllPropPresets,
  selectSelectedTake,
  selectSelectedTake3D,
  selectTrainingType,
  TrainingType,
} from "../../app/slices/TrainingSlice";
import { selectWarnings } from "../../app/slices/ValidationSlice";

export default function useValidation() {
  const { getValue } = useTrainingLocalization();

  const trainingType = useSelector(selectTrainingType);
  const currentTake360 = useSelector(selectSelectedTake);
  const currentTake3D = useSelector(selectSelectedTake3D);
  const actors = useSelector(selectActors);
  const allPropPresets = useSelector(selectAllPropPresets);

  const allWarnings = useSelector(selectWarnings);

  const getInteractionWarnings = (interaction: Interaction): string[] => {
    const factoryEntity = getInteractionFromFactory(interaction.type);
    if (!factoryEntity) return [];

    const take =
      trainingType === TrainingType.Training3D ? currentTake3D : currentTake360;
    if (!take) return [];

    return [
      ...new Set(factoryEntity.Validate?.(interaction, getValue, take, actors, allPropPresets)),
    ];
  };

  const getWarningsForInteraction = (interactionId: string) => {
    return allWarnings[interactionId] ?? [];
  };

  return {
    getInteractionWarnings,
    getWarningsForInteraction,
  };
}
